import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "page colt-express-page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", null, "Colt express", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("label", { for: "number-player-select" }, "Nombre de joueurs: ", -1)
const _hoisted_4 = ["value"]
const _hoisted_5 = ["for"]
const _hoisted_6 = ["id", "onUpdate:modelValue"]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    (!_ctx.isAvailableResult)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_3,
          _withDirectives(_createElementVNode("select", {
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.numberOfPlayer) = $event)),
            id: "number-player-select"
          }, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (n) => {
              return _createElementVNode("option", {
                key: n,
                value: n + 1
              }, _toDisplayString(n + 1), 9, _hoisted_4)
            }), 64))
          ], 512), [
            [_vModelSelect, _ctx.numberOfPlayer]
          ]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.numberOfPlayer, (m) => {
            return (_openBlock(), _createElementBlock("div", { key: m }, [
              _createElementVNode("label", {
                for: `player-name-${m}`
              }, _toDisplayString(`Joueur ${m}`) + ": ", 9, _hoisted_5),
              _withDirectives(_createElementVNode("input", {
                id: `player-name-${m}`,
                "onUpdate:modelValue": ($event: any) => ((_ctx.playerNames[m - 1]) = $event)
              }, null, 8, _hoisted_6), [
                [_vModelText, _ctx.playerNames[m - 1]]
              ])
            ]))
          }), 128)),
          _createElementVNode("button", {
            disabled: !_ctx.isValidForm,
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.affectCharacters && _ctx.affectCharacters(...args)))
          }, " Définir les personnages ", 8, _hoisted_7)
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.affectedCharacters, (result) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `${result.playerName}_${result.character}`
            }, [
              _createTextVNode(_toDisplayString(result.playerName) + " va jouer avec ", 1),
              _createElementVNode("b", null, _toDisplayString(result.character), 1)
            ]))
          }), 128)),
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.affectCharacters && _ctx.affectCharacters(...args)))
          }, "Recommencer"),
          _createElementVNode("button", {
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.resetAffectedCharacters && _ctx.resetAffectedCharacters(...args)))
          }, "Modifier")
        ], 64))
  ]))
}